import { useEffect } from "react";
import "./Category.scss";
import ShowAll from "../ShowAll/ShowAll";
import { getCategory } from "../../../services/products";
import { useCookies } from "react-cookie";
import Loading from "../../Menu/Loading/Loading";

export default function Category({
  active,
  cart,
  setCart,
  showAllId,
  setShowAllId,
  showMessage,
  setShowMessage,
  loading,
  setLoading,
}) {
  const [cookie] = useCookies(["access_token"]);

  useEffect(() => {
    active &&
      getCategory(active, cookie?.access_token).then((res) => {
        setShowAllId(res.id);
        setLoading(false);
      });
  }, [active, cookie?.access_token, setLoading, setShowAllId]);

  return (
    <>
      {loading ? (
        <Loading></Loading>
      ) : (
        <div className="promo-category">
          <ShowAll
            active={active}
            id={showAllId}
            setShowAllId={setShowAllId}
            isSubcategory={false}
            cart={cart}
            setCart={setCart}
            showMessage={showMessage}
            setShowMessage={setShowMessage}
          ></ShowAll>
        </div>
      )}
    </>
  );
}
